module.exports = __webpack_public_path__ + "img/interior-green.f1dc8a6b.png";